import { atom } from 'recoil';

export const CanBackToResultState = atom({
  key: 'CanBackToResultState',
  default: false,
});